import { toDigits } from 'utils/shared/phone/toDigits';

/**
 * Returns the digits-only national number with the country dial code removed.
 * Compares digits to digits so a leading + in either value can't shift the
 * slice and chop a real digit. Returns '' when nothing remains beyond the
 * dial code (e.g. an untouched pre-filled phone input) — callers must skip
 * persisting in that case since users.phone_number rejects empty strings.
 */
export const stripDialCode = (phoneNumber: string, dialCode: string): string => {
  const digits = toDigits(phoneNumber || '');
  const dialDigits = toDigits(dialCode || '');

  if (dialDigits && digits.startsWith(dialDigits)) {
    return digits.slice(dialDigits.length);
  }

  return digits;
};
